import { accessOf, canAutoSend, type AuthUser, type Company } from '@procumi/shared';

/**
 * Cine e în aplicație acum, pentru ecranele care au nevoie doar de rol (cine
 * aprobă, cine schimbă datele firmei). Un singur om pe sesiune, deci îl ține
 * App la fiecare desenare, ca țara în `market.ts`.
 */
let me: AuthUser = { id: '', email: '', name: '', role: 'buyer', isAdmin: false };

export function setMe(user: AuthUser): void {
  me = user;
}

export const currentUser = (): AuthUser => me;

let company: Company | null = null;

export function setCompany(c: Company): void {
  company = c;
}

/** Cererile pot pleca din Procumi (Echipă, Companie, probă). */
export const autoSendAllowed = (): boolean => !!company && canAutoSend(accessOf(company));

export const companyName = (): string => company?.name ?? '';

/** Limba implicită a firmei ('ro', 'en'…): pentru furnizorii noi. */
export const companyLocale = (): string => company?.locale ?? 'ro';
